import { Box, Select, Option, Typography } from "@mui/joy";
import { Wind } from "lucide-react";

interface IVentilationType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function VentilationType(props: IVentilationType) {
    const { value, onChange, loading } = { ...props };
    const selectedValue = value || null;

    const handleUpdate = (_event: any, newValue: string | null) => {
        if (loading) return;
        onChange(newValue || "");
    };

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Ventilation Type
            </Typography>

            <Select
                placeholder="Select ventilation type"
                value={selectedValue}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Wind size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Roof Vent">Roof Vent</Option>
                <Option value="Ridge Vent">Ridge Vent</Option>
            </Select>
        </Box>
    );
}
